export const shouldShowReportToggle = counts => {
  return counts?.templateCount !== null && counts?.templateCount !== undefined;
};
